export const initialState = {
  updatedSimulationPath: null,
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case 'PLAN_IMPACT_UPDATED_PATH_SET':
      return Object.assign({}, state, { updatedSimulationPath: action.path });
    default:
      return state;
  }
}
